const backgroundVideoList = [
    { name: 'corona.mp4', id: '864376705' },
    {name:'minutemade.mp4',id:'905322143'},
    { name: 'mercedes.mp4', id: '861220867' },
    { name: 'usnavy.mp4', id: '778392004' },
    { name: 'samsung.mp4', id: '780286712' },
    { name: 'yiii.mp4', id: '780461969' },
    { name: 'talcid.mp4', id: '707861260' },
    { name: 'Loreal.mp4', id: '639478662' },
    { name: 'dm.mp4', id: "710077184" },
    { name: 'icyhot.mp4', id: '705190688' },
    { name: 'BMW.mp4', id: '579103458' },
    { name: 'hauwei.mp4', id: '751639097' },
    { name: 'royalenf.mp4', id: '439726322' },
    { name: 'Bentley.mp4', id: '580631499' },
    { name: 'Porsche.mp4', id: '584619414' },
    { name: 'Sprite.mp4', id: '455864857' },
    { name: 'chevy.mp4', id: '705193038' },
    { name: 'Nissan.mp4', id: '498470734' }
]
export default backgroundVideoList
